import createTradePlanCopy from '../../../../../../../../classes/tradePlan/createTradePlanCopy';
import { addTradePlan } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/addtradeplanmessage/addTradePlan';
import {GetErrorMessage} from "./breakBounceErrorMessages";

const OPTION_INSTRUMENTS = new Set(['option', 'future_option']);

// TODO create unit tests for this logic
// TODO combine enterNow and submitTradePlan into a single unified function
// TODO if tradePlanForm is a copy, then validation messages do not appear on the screen :-(
// TODO using context menu to select candle break direction clears the Long/Short checkboxes -- it should not

// NOTE Create Trade Plan button on Chart Trading form (BottomRow.tsx) calls this function
// NOTE Also called in addBounceSetup and addBreakSetup when autoSend is on
// NOTE This ultimately calls addTradePlan, same as the Trade Plan form does -- however, the User Prefs (front run) do not seem to make it following this path
function resolveSetupPrice(tradePlanForm) {
  switch (tradePlanForm.setup) {
    case 'BREAK':
      return tradePlanForm.setupDetails.BREAK.priceToBreak;
    case 'BOUNCE':
      return tradePlanForm.setupDetails.BOUNCE.priceToBreak;
    default:
      return -1.0;
  }
}

function resolveSetupValidity({ setup, currentPrice, priceOfSetup, goLong, goShort }) {
  if (priceOfSetup < 0.0) {
    return { isLongSetupValid: false, isShortSetupValid: false };
  }

  if (setup === 'BREAK') {
    return {
      isLongSetupValid: goLong && Number(currentPrice) < Number(priceOfSetup),
      isShortSetupValid: goShort && Number(currentPrice) > Number(priceOfSetup),
    };
  }

  if (setup === 'BOUNCE') {
    return {
      isLongSetupValid: goLong && Number(currentPrice) > Number(priceOfSetup),
      isShortSetupValid: goShort && Number(currentPrice) < Number(priceOfSetup),
    };
  }

  return { isLongSetupValid: false, isShortSetupValid: false };
}

export function submitTradePlan({
  currentPrice,
  tradePlanForm,
  overrides,
  websocketStore,
}) {
  // TODO setup should be an enum, not a string
  const setup = tradePlanForm.setup;
  const instrument = tradePlanForm.instrument;
  const priceOfSetup = resolveSetupPrice(tradePlanForm);
  const { isLongSetupValid, isShortSetupValid } = resolveSetupValidity({
    setup,
    currentPrice,
    priceOfSetup,
    goLong: tradePlanForm.goLong,
    goShort: tradePlanForm.goShort,
  });
  let validateTP = false;
  let newInstance = null;
  let tpData = null;
  let optionData = null;
  let clearForm = false;

  if( Object.keys(overrides).length > 0) {
    // make a copy, so we can alter the direction of the TP we send
    newInstance = createTradePlanCopy({
      tradePlanDataInstance: tradePlanForm,
      keysToOverWrite: overrides,
      websocketStore,
    });
    validateTP = true
  } else if(isLongSetupValid || isShortSetupValid) {
    // make a copy, so we can alter the direction of the TP we send
    newInstance = createTradePlanCopy({
      tradePlanDataInstance: tradePlanForm,
      // TODO could both be true at the same time?
      keysToOverWrite: {goLong: isLongSetupValid, goShort: isShortSetupValid},
      websocketStore,
    });
    validateTP = true
  } else if( priceOfSetup === -1.0 ) {
    console.log('priceOfSetup is -1.0')
// no Break or Bounce, so check for Candle Break
    // TODO handle Candle Break if autosend
    if (tradePlanForm.entryTactics.CANDLE_BREAK) {
      if (tradePlanForm.entryTactics.MARKET_ORDER) {
        tradePlanForm.removeEntryTactic('MARKET_ORDER');
      }
      // TODO make sure CandleBreak direction conforms with Long/Short checkboxes
      const validationResult = tradePlanForm.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        tpData = tradePlanForm.returnJson();
      }
    } else {
      const err = GetErrorMessage({direction: tradePlanForm.direction, setup, currentPrice, price: priceOfSetup})
      tradePlanForm.setValidationStatus(err);
      return
    }
      // TODO handle no setup or candle break (market order?)
  } else {
    // TODO improve message
    tradePlanForm.setValidationStatus({
      status: false,
      message: `Current price is invalid for that setup`,
    });
  }

  if( validateTP ) {
    const validationResult = newInstance.validate();
    if (validationResult.status === false) {
      tradePlanForm.setValidationStatus(validationResult);
    } else {
      tpData = newInstance.returnJson();
      if( OPTION_INSTRUMENTS.has(instrument) ) {
        optionData = tradePlanForm.optionManagement.returnJson();
      }
    }
  }

  if( tpData ) {
    addTradePlan({tradePlanObject: tpData, options: optionData});
    tradePlanForm.setValidationStatus({
      status: true,
      message: 'Trade Plan Submitted.',
    });
    clearForm = true;
  }

  if( clearForm ) {
    // TP submitted, so start with a clean slate
    // TODO clear any Break or Bounce setup
    // TODO need a universal method to clear the form to a known and understood state
    tradePlanForm.setSetup('AD_HOC');
    tradePlanForm.clearSetupFilters();
    if (tradePlanForm.entryTactics.CANDLE_BREAK) {
      tradePlanForm.removeEntryTactic('CANDLE_BREAK');
    }
    if (tradePlanForm.exitTactics.BREAK_PRICE) {
      tradePlanForm.removeExitTactic('BREAK_PRICE');
    }
  }
/*
  if (instrument === 'option' && setup === 'BREAK') {
    const price = tradePlanForm.setupDetails.BREAK.priceToBreak;
    // const shortInitial = tradePlanForm.goShort;
    // const longInitial = tradePlanForm.goLong;
    if (Number(currentPrice) > Number(price)) {
      tradePlanForm.setGoLong(false);
      tradePlanForm.setGoShort(true);
      const validationResult = tradePlanForm.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = tradePlanForm.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
        tradePlanForm.setGoShort('' + shortInitial);
        tradePlanForm.setGoLong('' + longInitial);
      }
    } else if (Number(currentPrice) < Number(price)) {
      tradePlanForm.setGoLong(true);
      tradePlanForm.setGoShort(false);
      const validationResult = tradePlanForm.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = tradePlanForm.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
        tradePlanForm.setGoShort('' + shortInitial);
        tradePlanForm.setGoLong('' + longInitial);
      }
    }
    // this is the cleanup, I guess
    if (tradePlanForm.setup === 'BREAK' || tradePlanForm.setup === 'BOUNCE') {
      tradePlanForm.setSetup('AD_HOC');
    }
    if (tradePlanForm.entryTactics.CANDLE_BREAK) {
      tradePlanForm.removeEntryTactic('CANDLE_BREAK');
    }
    if (tradePlanForm.exitTactics.BREAK_PRICE) {
      tradePlanForm.removeExitTactic('BREAK_PRICE');
    }
  } else if (instrument === 'option' && setup === 'BOUNCE') {
    const price = tradePlanForm.setupDetails.BOUNCE.priceToBreak;
    console.log('tradePlanForm', tradePlanForm);
    console.log('tradePlanForm', price);
    // const shortInitial = tradePlanForm.goShort;
    // const longInitial = tradePlanForm.goLong;
    if (Number(currentPrice) > Number(price)) {
      tradePlanForm.setGoLong(true);
      tradePlanForm.setGoShort(false);
      const validationResult = tradePlanForm.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = tradePlanForm.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
        tradePlanForm.setGoShort('' + shortInitial);
        tradePlanForm.setGoLong('' + longInitial);
      }
    } else if (Number(currentPrice) < Number(price)) {
      tradePlanForm.setGoLong(false);
      tradePlanForm.setGoShort(true);
      const validationResult = tradePlanForm.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = tradePlanForm.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
        tradePlanForm.setGoShort('' + shortInitial);
        tradePlanForm.setGoLong('' + longInitial);
      }
    }
    // more cleanup
    if (tradePlanForm.setup === 'BREAK' || tradePlanForm.setup === 'BOUNCE') {
      tradePlanForm.setSetup('AD_HOC');
    }
    if (tradePlanForm.entryTactics.CANDLE_BREAK) {
      tradePlanForm.removeEntryTactic('CANDLE_BREAK');
    }
    if (tradePlanForm.exitTactics.BREAK_PRICE) {
      tradePlanForm.removeExitTactic('BREAK_PRICE');
    }
  } else if (setup === 'BREAK' && instrument !== 'option') {
    const price = tradePlanForm.setupDetails.BREAK.priceToBreak;
    if (Number(currentPrice) > Number(price)) {
      // different strategy here, make a copy and modify it, leaving the form alone
      const newInstance = createTradePlanCopy({
        tradePlanDataInstance: tradePlanForm,
        keysToOverWrite: { goLong: false, goShort: true },
        websocketStore,
      });
      //DEEP COPY HERE
      const validationResult = newInstance.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = newInstance.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
      }
    } else if (Number(currentPrice) < Number(price)) {
      const newInstance = createTradePlanCopy({
        tradePlanDataInstance: tradePlanForm,
        keysToOverWrite: { goLong: true, goShort: false },
        websocketStore,
      });

      const validationResult = newInstance.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = newInstance.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
      }
    } else if (Number(currentPrice) === Number(price)) {
      tradePlanForm.setValidationStatus({
        status: false,
        message: 'Break Price is equal to the current price.',
      });
    }
  } else if (setup === 'BOUNCE' && instrument !== 'option') {
    const price = tradePlanForm.setupDetails.BOUNCE.priceToBreak;
    if (Number(currentPrice) > Number(price)) {
      const newInstance = createTradePlanCopy({
        tradePlanDataInstance: tradePlanForm,
        keysToOverWrite: { goLong: true, goShort: false },
        websocketStore,
      });

      const validationResult = newInstance.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = newInstance.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
      }
    } else if (Number(currentPrice) < Number(price)) {
      const newInstance = createTradePlanCopy({
        tradePlanDataInstance: tradePlanForm,
        keysToOverWrite: { goLong: false, goShort: true },
        websocketStore,
      });

      const validationResult = newInstance.validate();
      if (validationResult.status === false) {
        tradePlanForm.setValidationStatus(validationResult);
      } else {
        const tpData = newInstance.returnJson();
        addTradePlan({ tradePlanObject: tpData });
        tradePlanForm.setValidationStatus({
          status: true,
          message: 'Trade Plan Submitted.',
        });
      }
    } else if (Number(currentPrice) === Number(price)) {
      tradePlanForm.setValidationStatus({
        status: false,
        message: 'Bounce Price is equal to the current price.',
      });
    }
  } else {
    // I think is just for no break, no bounce, just candle break
    const validationResult = tradePlanForm.validate();
    if (validationResult.status === false) {
      tradePlanForm.setValidationStatus(validationResult);
    } else {
      const tpData = tradePlanForm.returnJson();
      addTradePlan({ tradePlanObject: tpData });
      tradePlanForm.setValidationStatus({
        status: true,
        message: 'Trade Plan Submitted.',
      });
    }
    // cleanup
    tradePlanForm.setSetup('AD_HOC');
    if (tradePlanForm.entryTactics.CANDLE_BREAK) {
      tradePlanForm.removeEntryTactic('CANDLE_BREAK');
    }
    if (tradePlanForm.exitTactics.BREAK_PRICE) {
      tradePlanForm.removeExitTactic('BREAK_PRICE');
    }
  }
 */
}
